import { useCurrentPlanApi } from "@circle-react/components/SettingsApp/Plan/hooks/useCurrentPlanApi";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const useEmailHubBilling = () => {
  const { currentPlan, isCurrentPlanLoading } = useCurrentPlanApi();
  const { isLoading: isLoadingPunditContext, currentCommunity } =
    usePunditUserContext();

  const emailHubBilling = currentPlan?.email_hub_billing;
  const billingStatus = emailHubBilling?.billing_status;
  const emailHubBillingFreePeriod = currentPlan?.email_hub_billing?.free_period;

  const isTrialing = currentCommunity?.is_on_trial;
  const isInFreePeriod = !isTrialing && billingStatus === "free_period";
  const isActive = !isTrialing && billingStatus === "active";
  const isCancelAtPeriodEnd = billingStatus === "cancel_at_period_end";
  const isFreeTier = emailHubBilling?.free_tier ?? false;

  const isInactive =
    !(isActive || isInFreePeriod || isTrialing) || billingStatus === "inactive";

  return {
    emailHubBilling,
    emailHubBillingFreePeriod,
    isLoading: isCurrentPlanLoading || isLoadingPunditContext,
    billingStatus,
    isTrialing,
    isInFreePeriod,
    isActive,
    isInactive,
    isCancelAtPeriodEnd,
    isFreeTier,
  };
};
